export interface Application {
  appId: string;
}

export interface ProviderCustomerAddress {
  provider: string; // eg: shopify
  providerServiceId: string; // eg: hipperhiker.myshopify.com
  customerAddress: string | null; // eg: 234234982342 shopify customer id
  addressType?: string; // optional eg: "customerId" (considering provider)
}

export interface Product {
  productId: string;
  variantId: string;
}

export interface ProductCategory {
  categoryId: string;
  categoryHandle: string;
}

export interface PageView {
  title: string;
  referrer: string;
  userAgent: string;
  url: string;
  host: string;
  path: string;
  query: string;
  hash: string;
  viewportWidth: number;
  viewportHeight: number;
}

export const DEFAULT_LOG_MESSAGE_TYPE = 'custom';

export const enum SEVERITY {
  DEBUG = 0,
  INFO = 1,
  WARNING = 2,
  ERROR = 3,
}

export interface LogEntry {
  message?: string;
  messageType?: string;
  severity?: SEVERITY;
  stack?: string;
  data?: { [key: string]: any };
}

export type Timestamp = number;
